import {Component, Input} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";
import {SavedCardDto} from "../../models/saved-card.models";
import {SavedCardService} from "../../../../services/saved-card.service";

@Component({
  selector: 'app-delete-card-dialog',
  templateUrl: './delete-card-dialog.component.html',
  styleUrls: ['./delete-card-dialog.component.scss']
})
export class DeleteCardDialogComponent {
  @Input() cardData!: SavedCardDto


  constructor(
    private modalService: ModalService,
    private savedCardService: SavedCardService
  ) {
  }

  closeModal() {
    this.modalService.closeModal()
  }

  deleteCard() {
    this.savedCardService.deleteCard$.next(this.cardData)
  }
}
